"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var storage_1 = require("../utils/storage");
var StorageAdapter = /** @class */ (function (_super) {
    __extends(StorageAdapter, _super);
    function StorageAdapter(options) {
        var _this = _super.call(this, options) || this;
        _this.getItem = options.getter;
        _this.setItem = options.setter;
        return _this;
    }
    StorageAdapter.prototype.restoreExperimentVariant = function (experimentName) {
        var experiment = this.getItem(this.getSaveName(experimentName));
        if (experiment || experiment !== undefined) {
            return JSON.parse(experiment);
        }
        else {
            return null;
        }
    };
    StorageAdapter.prototype.addExperimentVariant = function (variant) {
        this.setItem(this.getSaveName(variant.experimentName), JSON.stringify(variant.variant));
        this.add(variant);
    };
    return StorageAdapter;
}(storage_1.Storage));
exports.StorageAdapter = StorageAdapter;
//# sourceMappingURL=storageAdapter.js.map